import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { Email, Fill } from './LegalLayout';
import { OWNER } from '../../config/legal';

// Owner identification and terms of use (LSSI-CE art. 10).
const AvisoLegal = () => (
  <LegalLayout title="Aviso legal">
    <h2>Quién está detrás de webspector</h2>
    <dl>
      <dt>Titular</dt>
      <dd>
        <Fill value={OWNER.name} label="nombre y apellidos" />
      </dd>
      <dt>NIF</dt>
      <dd>
        <Fill value={OWNER.nif} label="NIF" />
      </dd>
      <dt>Domicilio</dt>
      <dd>
        <Fill value={OWNER.address} label="domicilio" />
      </dd>
      <dt>Email</dt>
      <dd>
        <Email />
      </dd>
      <dt>Web</dt>
      <dd>webspector.es</dd>
    </dl>

    <h2>Qué es webspector</h2>
    <p>
      Un servicio en línea de GEO (optimización para motores generativos) para negocios locales: comprueba si los
      asistentes de inteligencia artificial recomiendan un negocio cuando alguien les pregunta por lo que vende, y
      prepara un informe con lo que puede mejorar. La comprobación es gratuita; el informe completo es de pago, según
      las <Link to="/legal/condiciones">condiciones de venta</Link>.
    </p>

    <h2>Uso de la web</h2>
    <p>
      Puedes usar la web para comprobar tu propio negocio o uno sobre el que tengas interés legítimo. No está permitido
      usarla de forma automatizada o masiva, intentar saltarse sus límites o usarla para fines ilícitos.
    </p>

    <h2>Sobre los resultados</h2>
    <p>
      Los resultados se obtienen preguntando a un modelo de inteligencia artificial con búsqueda web en tiempo real,
      como lo haría un cliente. Las respuestas de la IA cambian con el tiempo y cada asistente (ChatGPT, Gemini,
      Perplexity…) responde a su manera, así que los resultados son una señal orientativa, no una medida exacta de lo
      que verá cada persona. webspector no garantiza que un negocio vaya a ser recomendado por ningún asistente tras
      aplicar sus recomendaciones.
    </p>
    <p>
      webspector no tiene relación con OpenAI, Google, Perplexity ni ninguna otra empresa de IA. Sus nombres y marcas
      pertenecen a sus titulares y se citan solo para explicar el servicio. Los nombres de negocios que aparecen en los
      resultados salen de las respuestas de la IA.
    </p>

    <h2>Propiedad intelectual</h2>
    <p>
      El diseño, los textos y el código de esta web pertenecen a su titular. Los textos que el informe prepara para tu
      negocio (el apartado «Hecho para ti») son para ti: puedes usarlos, cambiarlos y publicarlos libremente.
    </p>

    <h2>Enlaces y disponibilidad</h2>
    <p>
      La web puede enlazar a páginas de terceros, de cuyo contenido no somos responsables. Intentamos que el servicio
      esté siempre disponible, pero puede haber interrupciones por mantenimiento o por fallos de los proveedores.
    </p>

    <h2>Ley aplicable</h2>
    <p>
      Esta web se rige por la ley española. Si tienes cualquier problema, escríbenos a <Email /> e intentaremos
      resolverlo. Si eres consumidor, puedes reclamar ante los juzgados de tu domicilio.
    </p>
  </LegalLayout>
);

export default AvisoLegal;
